<template>
  <el-dialog :title="$t('addAServTypeMenu.add')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="addAServTypeMenuInfo" label-width="120px">
      <el-form-item :label="$t('addAServTypeMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('addAServTypeMenu.menuNameRequired') }]">
        <el-input v-model="addAServTypeMenuInfo.hktName" :placeholder="$t('addAServTypeMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('addAServTypeMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('addAServTypeMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('addAServTypeMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="addAServTypeMenuInfo.hktDesc" :placeholder="$t('addAServTypeMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('addAServTypeMenu.label')" prop="label">
        <el-input v-model="addAServTypeMenuInfo.label" :placeholder="$t('addAServTypeMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('addAServTypeMenu.servType')" prop="tHktId"
        :rules="[{ required: true, message: $t('addAServTypeMenu.servTypeRequired') }]">
        <el-select v-model="addAServTypeMenuInfo.tHktId" :placeholder="$t('addAServTypeMenu.selectServType')"
          style="width:100%">
          <el-option :label="$t('addAServTypeMenu.selectServType')" value="" />
          <el-option v-for="servType in addAServTypeMenuInfo.servTypes" :key="servType.hktId" :label="servType.hktName"
            :value="servType.hktId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAServTypeMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('addAServTypeMenu.sortRequired') }]">
        <el-input v-model="addAServTypeMenuInfo.seq" :placeholder="$t('addAServTypeMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('addAServTypeMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('addAServTypeMenu.showStatusRequired') }]">
        <el-select v-model="addAServTypeMenuInfo.isShow" :placeholder="$t('addAServTypeMenu.selectShowStatus')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveAddAServTypeMenuInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductMenu, queryHousekeepingType } from '@/api/admin/shopProductType/shopProductTypeApi'
import UploadImage from '@/components/system/UploadImage'


export default {
  name: 'AddAServTypeMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addAServTypeMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '1',
        isShow: '',
        typeCd: '2002',
        tHktId: '',
        servTypes: []
      }
    }
  },
  methods: {
    open(data = {}) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.addAServTypeMenuInfo = {
          ...this.addAServTypeMenuInfo,
          ...data
        }
        if (data.hktIcon) {
          this.$refs.uploadImage.setImages([data.hktIcon])
        } else {
          this.$refs.uploadImage.clearImages()
        }
        this.loadServTypes()
      })
    },
    async loadServTypes() {
      try {
        const res = await queryHousekeepingType({
          page: 1,
          row: 100,
          typeCd: '1001',
          shopId: '9999'
        })
        this.addAServTypeMenuInfo.servTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    handleUploadImage(photos) {
      this.addAServTypeMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveAddAServTypeMenuInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.addAServTypeMenuInfo.url = `/pages/homemaking/cateServ?hktId=${this.addAServTypeMenuInfo.tHktId}`

        await saveProductMenu(this.addAServTypeMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>